import { getUrlParam } from '@/libs/functions/getValue'
import langDepJson from '../../../locale_config.json'
import { LangController } from './LangController'
import { eventCenter } from '../qiankunRouter'
export { convertToUpperCaseWithRegex } from '@/libs/functions/lang'
// console.log('langDepJson: ', langDepJson)

let langController: LangController

export async function initLang() {
  if (langController) return langController
  langController = new LangController(eventCenter, true)
  return langController
}
